export const getNullProps = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (obj[key] === null) acc.push(key)
    return acc
  }, [])
}